import { render, staticRenderFns } from "./wuzi_statistic.vue?vue&type=template&id=3702fe90"
import script from "./wuzi_statistic.vue?vue&type=script&lang=js"
export * from "./wuzi_statistic.vue?vue&type=script&lang=js"
import style0 from "./wuzi_statistic.vue?vue&type=style&index=0&id=3702fe90&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports